// The build's version, shown quietly at the bottom of every screen so a person
// reporting a problem can say which build they were on.
//
// Kept as a constant rather than imported from `package.json`: `tsconfig.app.json`
// scopes `include` to `src` and does not set `resolveJsonModule`, so importing it
// would mean build-config changes in three places (both Vite configs and Vitest)
// for one string. `version.test.ts` asserts this matches `app/package.json`, so
// the two cannot drift — bump both together.
export const APP_VERSION = '0.2.0'
